<h1 mat-dialog-title>{{'INVOICE.PUBLISH_DIALOG.TITLE' | translate}}</h1>
<span>{{'INVOICE.PUBLISH_DIALOG.DESCRIPTION' | translate}}</span>

<mat-divider style="margin: 10px 0;"></mat-divider>

<div style="padding: 10px 0;">
  <form [formGroup]="publishFormGroup" fxLayout="column" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
      <mat-checkbox formControlName="tos_1"></mat-checkbox>
      <div style="padding-top: 3px;">
            <span style="cursor: pointer"
                  (click)="publishFormGroup.get('tos_1').setValue(!publishFormGroup.get('tos_1').value)">
              {{'INVOICE.PUBLISH_DIALOG.TOS_1' | translate}}
            </span>
        <a href="assets/pdf/b_conditions.pdf" target="_blank">{{'INVOICE.PUBLISH_DIALOG.TOS_1_LINK' | translate}}</a>.
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
      <mat-checkbox formControlName="tos_2"></mat-checkbox>
      <div style="padding-top: 3px;">
            <span style="cursor: pointer"
                  (click)="publishFormGroup.get('tos_2').setValue(!publishFormGroup.get('tos_2').value)">
              {{'INVOICE.PUBLISH_DIALOG.TOS_2' | translate}}
            </span>
        <a href="assets/pdf/s_conditions.pdf" target="_blank">{{'INVOICE.PUBLISH_DIALOG.TOS_2_LINK' | translate}}</a>.
      </div>
    </div>
  </form>

</div>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" [disabled]="isPublishing" class="btn-margin">
    <span>{{'INVOICE.PUBLISH_DIALOG.CANCEL' | translate}}</span>
  </button>

  <button mat-button (click)="submit()" [disabled]="!publishFormGroup.valid || isPublishing"
          color="accent" class="btn-margin" fxLayoutAlign="center center"
          style="width: 90px">
    <ng-container *ngIf="!isPublishing; else publishing">
      <span>{{'INVOICE.PUBLISH_DIALOG.PUBLISH' | translate}}</span>
    </ng-container>
    <ng-template #publishing>
      <mat-progress-spinner mode="indeterminate" color="primary" [diameter]="18"></mat-progress-spinner>
    </ng-template>
  </button>

</mat-dialog-actions>
